import React from 'react';
import { useField } from 'formik';

import styled from 'styled-components';
import ErrorHint from '@zimpel/common/components/ErrorHint';
import CheckboxLabel from '@zimpel/common/components/CheckboxLabel';
import RequiredMarker from '@zimpel/common/components/RequiredMarker';

type Props = { name: string, label: string, isRequired?: boolean }

const AlignedErrorHint = styled(ErrorHint)`
  margin-left: 18px;
`;

const FormikCheckbox: React.FC<Props> = ({ name, label, isRequired }) => {
  const [field, meta] = useField(name);
  return (
    <>
      <CheckboxLabel>
        <input type="checkbox" {...field} />
        { label }
        { isRequired && <RequiredMarker /> }
      </CheckboxLabel>
      {meta.error && <AlignedErrorHint>{meta.error}</AlignedErrorHint>}
    </>
  );
};

export default FormikCheckbox;
